module.exports = __webpack_public_path__ + "img/placeholder_mom_3x.c7308f93.png";